<template>
  <div class="ticket-audit">
    <span>{{ audit.display_text }}</span>
    <div v-b-tooltip.hover.left :title="detailedDate(audit.created_at)" class="timestamp">
      {{prettyDate(audit.created_at)}}
    </div>
    <hr class="audit-hr">
  </div>
</template>

<script>
import { helpersMixins } from '@/mixins/helpersMixins'
export default {
  name: 'TicketAudit',
  mixins: [helpersMixins],
  props: {
    audit: Object
  }
}
</script>

<style>
  .ticket-audit {
    padding: 9px 5px;
    font-size: 12px;
    color: #7A858E;
  }
  .timestamp {
    float: right;
    padding-left: 5px;
  }
  .audit-hr {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/TicketAudit.vue